import { FormGroup, FormControl, AbstractControl, ValidatorFn } from '@angular/forms';
import { Type, Operator } from './custom-validator.model';

/* Compare Validator - From group validators*/
export function compareValidator(controlToCompareKey: string, type: Type, operator: Operator,
    valueToCompare: any = null, isReverse: boolean = false, error: string = 'invalidCompare'): ValidatorFn {
    //return (formGroup: FormGroup): { [key: string]: any } => {
    return (formControl: FormControl): { [key: string]: any } => {
        let res: { [key: string]: any };

        //let controlToValidate = formGroup.controls[controlToValidateKey].value;
        let controlToValidate = formControl.value;
        let compareControl = controlToCompareKey ? formControl.root.get(controlToCompareKey) : null;

        //Basic input check
        //ControlToValidate should have any value. If controlToCompareKey has value it should have formgroup
        //if (!controlToValidate || (controlToCompareKey && !formGroup.root)) return null;
        if (!controlToValidate || (controlToCompareKey && !formControl.root)) return null;
        //If reverse is true it should have controlToCompareKey
        if (isReverse && !compareControl)
            throw new Error("If reverse is true, controlToCompareKey should not be null or empty.");
        if (!controlToCompareKey && !valueToCompare && operator != Operator.DataTypeCheck)
            throw new Error("If controlToCompareKey and valueToCompare is null, operator should be a DataTypeCheck.");

        //If ControlToValidate value is assigned to compare value, it is going to perform datatype check. In that case ControlToCompare
        // and ValueToCompare should be null
        let compareValue = controlToCompareKey ? compareControl.value : (valueToCompare || controlToValidate);

        try {
            //datatype conversion
            controlToValidate = type == Type.number ? +controlToValidate : type == Type.Date ? new Date(controlToValidate) : controlToValidate;
            compareValue = type == Type.number ? +compareValue : type == Type.Date ? new Date(compareValue) : compareValue;

            switch (operator) {
                case Operator.Equal:
                    res = !(controlToValidate == compareValue) ? { [error]: { value: controlToValidate } } : null;
                    break;
                case Operator.NotEqual:
                    res = !(controlToValidate != compareValue) ? { [error]: { value: controlToValidate } } : null;
                    break;
                case Operator.GreaterThan:
                    res = !(controlToValidate > compareValue) ? { [error]: { value: controlToValidate } } : null;
                    break;
                case Operator.GreaterThanEqual:
                    res = !(controlToValidate >= compareValue) ? { [error]: { value: controlToValidate } } : null;
                    break;
                case Operator.LessThan:
                    res = !(controlToValidate < compareValue) ? { [error]: { value: controlToValidate } } : null;
                    break;
                case Operator.LessThanEqual:
                    res = !(controlToValidate <= compareValue) ? { [error]: { value: controlToValidate } } : null;
                    break;
                case Operator.DataTypeCheck:
                    // res = !(typeof controlToValidate === typeof compareValue) ? { [error]: true } : null;
                    res = ((!controlToValidate && controlToValidate !== 0) || (!compareValue && compareValue !== 0))
                        ? { [error]: { value: controlToValidate } } : null;
                    break;
                default:
                    res = null;
            }
        }
        catch (e) {
            res = { [error]: { value: controlToValidate } };
        }
        if (isReverse) {
            if (res) {
                compareControl.setErrors({ [error]: { value: compareValue } });
                res = null;
            }
            else {
                delete compareControl.errors[error];
                if (!Object.keys(compareControl.errors).length)
                    compareControl.setErrors(null);
            }
        }
        return res;
    };
}

// Email Validator SINGLE FIELD VALIDATOR
export function emailValidator(control: FormControl): { [key: string]: any } {
    var emailRegexp = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4})(,[\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4}){0,4}$/i;
    return (control.value && !emailRegexp.test(control.value)) ? { invalidEmail: true } : null;
}
export function webUrlValidator(control: FormControl): { [key: string]: any } {
    //var emailRegexp = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    // /^(?:(ftp|http|https)?:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}$/gi;
    //var webRegexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    var webRegexp = /^(?:(ftp|http|https)?:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}$/gi;
    return (control.value && !webRegexp.test(control.value)) ? { invalidUrl: true } : null;
}


//multiple email validation
export function multipleEmailValidator(control: FormControl): { [key: string]: any } {
    //var emailRegexp = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    var emailRegexp = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4})(,[\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4}){0,4}$/i;
    var email = control.value;

    if (email != "") {
        debugger;
        if (email == null) return;
        let sep: string[] = [',', ';'];
        var emailArray = email.split(new RegExp('[' + sep.join('') + ']'));
        var invEmails = "";
        if (emailArray.length > 0) {
            for (var i = 0; i <= (emailArray.length - 1); i++) {

                if (control.value && !emailRegexp.test(emailArray[i])) {
                    invEmails += emailArray[i] + "\n";
                }
                else {

                }
            }
            if (invEmails != "") {
                return { invalidEmail: true };
            }
            else {
                return null;//{ invalidEmail: false };
            }
        }
        else {
            return null;
        }
    }
    //  return (control.value && !emailRegexp.test(control.value)) ? { invalidEmail: true } : null;
}

export function numaricValidator(control: FormControl): { [key: string]: any } {
    // var webRegexp = /^(\d+)?\.((\d+)(-(\d+))?)?$/; 
    var webRegexp = /^(\d+)?$/;
    return (control.value && !webRegexp.test(control.value)) ? { invalidNumber: true } : null;
}

//Latitude
export function latValidator(control: FormControl): { [key: string]: any } {
    var webRegexp = /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/;
    return (!webRegexp.test(control.value)) ? { invalidLat: true } : null;
}

//Longitude
export function lonValidator(control: FormControl): { [key: string]: any } {
    var webRegexp = /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|[0-1][0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/;
    return (!webRegexp.test(control.value)) ? { invalidLon: true } : null;
}



